<!-- 设备保养记录 -->
<style>
.baoyangxianginput {
  width: 1.25rem;
}
.baoyangxianginputDetail {
  width: 0.6rem;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/repair/bill/page" getKey="rows" :columns="columns" @afterGet="afterGet">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('weixiudanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select :max="1" :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('weixiuzhuangtai')">
            <yi_dictionary_select :type="'EQUIPMENT_REPAIR_STATUS'" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jinjichengdu')">
            <yi_dictionary_select :type="'EQUIPMENT_REPAIR_LEVEL'" :ids.sync="yt.conditions.level"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('baoxiushijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_equipment_repair_create')">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('customSave', null, 'w1')" type="primary" v-if="utils.checkPower('web_equipment_repair_create_custom')">
          {{ $t('customSave') }}
        </el-button>
        <el-button :loading="exportLoading" size="mini" @click="exportDetailExcel()" v-if="utils.checkPower('web_equipment_repair_export_detail')" type="primary">
          {{ $t('daochumingxixiang') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #tupian="scope">
        <yi_upload :readOnly="true" :ids.sync="scope.row.imageIds" :limit="5"> </yi_upload>
      </template>

      <template #weixiudengdanshichang="scope">
        {{ formatMilliseconds(scope.row.repairWaitingTime) }}
      </template>

      <template #weixiuhaoshi="scope">
        {{ formatMilliseconds(scope.row.repairDuration) }}
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 1">
            <el-popconfirm :title="$t('quedingkaishiweixiu?')" :confirm-button-text="$t('kaishiweixiu')" @confirm="startRepair(scope.row)">
              <el-button type="text" slot="reference" :loading="scope.row.startRepairLoading" v-if="utils.checkPower('web_equipment_repair_start')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备维修-开始维修' } }">{{ $t('kaishiweixiu') }} </el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w2')" v-if="utils.checkPower('web_equipment_repair_update')">{{ $t('bianji') }} </el-button>
            <el-button v-if="scope.row.status == 1 && utils.checkPower('web_equipment_repair_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/repair/bill/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 2">
            <el-button
              type="text"
              v-if="utils.checkPower('web_equipment_repair_finish')"
              @click="
                yt.showEditDialog('wanchengweixiu', scope.row, 'w2', beforeShowEditDialog);
                getRepairMethodItem(scope.row);
              "
            >
              {{ $t('wanchengweixiu') }}
            </el-button>
            <el-button type="text" @click="yt.showEditDialog('zhongzhiweixiu', scope.row, 'w1')" v-if="utils.checkPower('web_equipment_repair_stop')">
              {{ $t('zhongzhiweixiu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 3 || scope.row.status == 4">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('weixiuxiangqing', scope.row, 'w2');
                getRepairMethodItem(scope.row);
              "
            >
              {{ $t('weixiuxiangqing') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增弹窗-->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <!-- 选择设备 -->
          <el-form-item :label="$t('shebeimingcheng')" label-width="150px" size="mini" required>
            <yi_cross_select :component="'web_base_equipment_list'" :max="1" :ids.sync="yt.editObj.equipmentId"> </yi_cross_select>
          </el-form-item>
          <!-- 紧急程度-->
          <el-form-item :label="$t('jinjichengdu')" label-width="150px" required>
            <yi_dictionary_select :type="'EQUIPMENT_REPAIR_LEVEL'" :ids.sync="yt.editObj.level"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('xuqiushijian')" label-width="150px">
            <yi_time_input :minMaxBase="'current'" type="datetime" :time.sync="yt.editObj.requiredTime"></yi_time_input>
          </el-form-item>
          <!-- 故障描述 -->
          <el-form-item :label="$t('guzhangmiaoshu')" label-width="150px" required>
            <el-input type="textarea" max="400" v-model="yt.editObj.description" style="width: 200px;"> </el-input>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <!-- :isShowLimitMsg="false" -->
            <yi_upload style="margin-left: 20px;" :accept="'image/png, image/jpeg,image/gif'" :ids.sync="yt.editObj.imageIds" :limit="5">
              <div slot="limitMsg">
                <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                  {{ $t('zuiduoshangchuan') }}
                </span>
                <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                  <span>5</span>
                  <span style="color: #909399;font-size: 14px;font-weight: normal;">
                    {{ $t('zizhichitupian') }}
                  </span>
                </span>
              </div>
            </yi_upload>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/equipment/repair/bill/create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备维修-新增' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'customSave'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <!-- 选择设备 -->
          <el-form-item :label="$t('shebeimingcheng')" label-width="150px" size="mini" required>
            <yi_cross_select :component="'web_base_equipment_list'" :max="1" :ids.sync="yt.editObj.equipmentId"> </yi_cross_select>
          </el-form-item>
          <!-- 紧急程度-->
          <el-form-item :label="$t('jinjichengdu')" label-width="150px" required>
            <yi_dictionary_select :type="'EQUIPMENT_REPAIR_LEVEL'" :ids.sync="yt.editObj.level"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('xuqiushijian')" label-width="150px" required>
            <yi_time_input :minMaxBase="'current'" type="datetime" :time.sync="yt.editObj.requiredTime"></yi_time_input>
          </el-form-item>
          <!-- 故障描述 -->
          <el-form-item :label="$t('guzhangmiaoshu')" label-width="150px" required>
            <el-input type="textarea" max="400" v-model="yt.editObj.description" style="width: 200px;"> </el-input>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <!-- :isShowLimitMsg="false" -->
            <yi_upload style="margin-left: 20px;" :accept="'image/png, image/jpeg,image/gif'" :ids.sync="yt.editObj.imageIds" :limit="5">
              <div slot="limitMsg">
                <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                  {{ $t('zuiduoshangchuan') }}
                </span>
                <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                  <span>5</span>
                  <span style="color: #909399;font-size: 14px;font-weight: normal;">
                    {{ $t('zizhichitupian') }}
                  </span>
                </span>
              </div>
            </yi_upload>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="customSave()" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备维修-新增' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <!-- 选择设备 -->
          <el-form-item :label="$t('shebeimingcheng')" label-width="150px" required size="mini">
            <yi_data_select :type="'equipment'" :ids.sync="yt.editObj.equipmentId" disabled> </yi_data_select>
          </el-form-item>
          <!-- 紧急程度-->
          <el-form-item :label="$t('jinjichengdu')" label-width="150px" required>
            <yi_dictionary_select :type="'EQUIPMENT_REPAIR_LEVEL'" :ids.sync="yt.editObj.level"> </yi_dictionary_select>
          </el-form-item>
          <!-- 故障描述 -->
          <el-form-item :label="$t('guzhangmiaoshu')" label-width="150px" required>
            <el-input type="textarea" max="400" v-model="yt.editObj.description" style="width: 200px;"> </el-input>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <yi_upload style="margin-left: 20px;" :accept="'image/png, image/jpeg,image/gif'" :ids.sync="yt.editObj.imageIds" :limit="5">
              <div slot="limitMsg">
                <span style="margin-left: 12px;font-size: 14px;color: #909399;">
                  {{ $t('zuiduoshangchuan') }}
                </span>
                <span style="font-weight: bold;font-size: 14px;color: #419FFF;;">
                  <span>5</span>
                  <span style="color: #909399;font-size: 14px;font-weight: normal;">
                    {{ $t('zizhichitupian') }}
                  </span>
                </span>
              </div>
            </yi_upload>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/equipment/repair/bill/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- "完成维修"弹窗 -->
      <template v-if="yt.editObj.action == 'wanchengweixiu'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('guzhangleixing')" label-width="424px" size="mini" style="margin-left: -195px;margin-top: 50px;">
              <yi_dictionary_select :type="'CUSTOMER_EQUIPMENT_FAULT_TYPE'" :ids.sync="yt.editObj.equipmentFaultType"> </yi_dictionary_select>
            </el-form-item>
            <br />
            <el-form-item :label="$t('beizhu')" label-width="230px" size="mini">
              <el-input style="width: 300px;" type="text" v-model="yt.editObj.remark"></el-input>
            </el-form-item>

            <el-form-item :label="$t('shangchuanwenjian')" label-width="230px" size="mini">
              <yi_upload :readOnly="true" :ids.sync="yt.editObj.fileInfoIds" :limit="10"></yi_upload>
              <div>
                <yi_upload ref="up" accept=".bmp,.gif,.jpg,.jpeg,.png" btName="shangchuantupian" :ids.sync="yt.editObj.imageIds" :limit="5" @afterUpload="afterUpload" @afterRemove="afterRemove">
                  <template slot="limitMsg">
                    <span></span>
                  </template>
                </yi_upload>
              </div>
            </el-form-item>
            <br />
          </el-form>
          <el-form>
            <div style="display: flex">
              <el-form-item :label="$t('weixiufangfa')" required label-width="210px"> </el-form-item>
              <el-form-item :label="$t('weixiushuoming')" required label-width="210px"> </el-form-item>
              <el-form-item :label="$t('beizhu')" label-width="180px"> </el-form-item>
            </div>

            <el-form-item v-for="(item, index) in yt.editObj.methodList" :key="index" label-width="80px" size="mini">
              <el-col :span="0.1">
                <el-button type="text" icon="el-icon-remove-outline" @click="deleteItem(index)"> </el-button>
              </el-col>
              <el-col :span="0.8">&nbsp;</el-col>
              <el-col :span="4">
                <yi_dictionary_select :type="'SBWXFF'" :ids.sync="item.method"> </yi_dictionary_select>
                <!--								<el-select v-model="item.method" size="mini">-->
                <!--									<el-option v-for="(repairMethodItem, index) in repairMethod" :key="index"-->
                <!--										:label="repairMethodItem.label" :value="repairMethodItem.id"></el-option>-->
                <!--								</el-select>-->
              </el-col>
              <el-col :span="3">&nbsp;</el-col>
              <el-col :span="3">
                <el-input v-model="item.remark" class="baoyangxianginputDetail" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="2">
                <el-input v-model="item.repairRemark" class="baoyangxianginputDetail" type="text" size="mini"> </el-input>
              </el-col>
            </el-form-item>
            <el-form-item label-width="80px" size="mini">
              <el-col :span="4">
                <el-button type="text" icon="el-icon-circle-plus-outline" @click="addItem">
                  {{ $t('zengjiayitiaoweixiufangfa') }}
                </el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/equipment/repair/bill/saveDraft', beforeSave)" v-if="utils.checkPower('web_equipment_repair_save_draft')" :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备维修-保存草稿' } }">
            {{ $t('baocuncaogao') }}
          </el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/equipment/repair/bill/finish', beforeSave)" type="primary" :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备维修-完成维修' } }">
            {{ $t('wanchengweixiu') }}
          </el-button>
        </span>
      </template>

      <!--"终止维修"弹窗 -->
      <template v-if="yt.editObj.action == 'zhongzhiweixiu'">
        <div style="display: flex;flex-direction: column;align-items: flex-start;padding: 0 60px;">
          <div style="display: flex;align-items: center;">
            <i style="font-size: 35px;color:#ffaa00;" class="el-icon-warning"></i>
            <div style="margin-left: 12px;">
              <div>{{ $t('zhongzhiweixiu_msg') }}</div>
              <div style="margin-top: 1	0px;">{{ $t('shifouquedingzhongzhiweixiu') }}?</div>
            </div>
          </div>
          <div style="margin-top: 30px;margin-left: 8px;" class="dialog-scroller-form">
            <el-form :inline="true" ref="form" size="mini">
              <!-- 备注 -->
              <el-form-item :label="$t('beizhu')" required>
                <el-input :autosize="{ minRows: 5 }" style="width: 250px;" maxlength="400" type="textarea" v-model="yt.editObj.remark"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/equipment/repair/bill/stop')" type="primary" :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '设备维修-终止维修' } }">
            {{ $t('zhongzhiweixiu') }}
          </el-button>
        </span>
      </template>
      <!-- "维修详情"弹窗-状态为成功 -->
      <template v-if="yt.editObj.action == 'weixiuxiangqing' && yt.editObj.status != 4">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <!-- 故障类型 -->
            <el-form-item :label="$t('guzhangleixing')" label-width="410px" size="mini" style="margin-left: -130px;margin-top: 50px;" class="noborder" v-if="yt.editObj.equipmentFaultType">
              <yi_dictionary_select disabled :type="'CUSTOMER_EQUIPMENT_FAULT_TYPE'" :ids.sync="yt.editObj.equipmentFaultType"> </yi_dictionary_select>
            </el-form-item>
            <br />
            <!-- 备注 -->
            <el-form-item :label="$t('beizhu')" label-width="280px" size="mini">
              {{ yt.editObj.remark }}
              <!-- <el-input style="width: 300px;" type="textarea" v-model="yt.editObj.remark" disabled></el-input> -->
            </el-form-item>
            <br />
            <el-form-item :label="$t('shangchuantupian')" label-width="280px" size="mini">
              <yi_upload :readOnly="true" :ids.sync="yt.editObj.fileInfoIds" :limit="10"></yi_upload>
            </el-form-item>
            <br />
          </el-form>
          <el-form>
            <div style="display: flex">
              <el-form-item :label="$t('weixiufangfa')" required label-width="210px"> </el-form-item>
              <el-form-item :label="$t('weixiushuoming')" required label-width="210px"> </el-form-item>
              <el-form-item :label="$t('beizhu')" label-width="180px"> </el-form-item>
            </div>
            <el-form-item v-for="(item, index) in repairMethodItemList" label-width="80px" size="mini">
              <el-col :span="0.8">&nbsp;</el-col>
              <el-col :span="4">
                <el-input :value="item.methodName" />
              </el-col>
              <el-col :span="3">&nbsp;</el-col>
              <el-col :span="3">
                <el-input class="baoyangxianginput" :value="item.remark" type="text" size="mini"> </el-input>
              </el-col>
              <el-col :span="4">&nbsp;</el-col>
              <el-col :span="4">
                <el-input class="baoyangxianginput" :value="item.repairRemark" type="text" size="mini"> </el-input>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <!-- "维修详情"- 维修失败弹窗 -->
      <template v-if="yt.editObj.action == 'weixiuxiangqing' && yt.editObj.status == 4">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <!-- 备注 -->
          <el-form-item :label="$t('beizhu')" label-width="230px" size="mini">
            <el-input :autosize="{ minRows: 5 }" style="width: 200px;" type="textarea" disabled v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <br />
          <el-form-item :label="$t('shangchuantupian')" label-width="280px" size="mini">
            <yi_upload :readOnly="true" :ids.sync="yt.editObj.fileInfoIds" :limit="10"></yi_upload>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import maintenance_item from '@@/pages/web/equipment/maintenance/maintenance_item';
import XLSX from 'xlsx';

export default {
  name: 'web_equipment_repair_list',
  components: {
    maintenance_item
  },
  data() {
    return {
      // 已上传的图片id
      imageIds: [],
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      statusMap: {
        1: {
          color: '#F56C6C',
          text: this.$t('daichuli')
        },
        2: {
          color: '#E6A23C',
          text: this.$t('weixiuzhong')
        },
        3: {
          color: '#67C23A',
          text: this.$t('yiwancheng')
        },
        4: {
          color: '#969696',
          text: this.$t('shibai')
        }
      },
      repairMethod: [],
      repairMethodItemList: [],
      columns: [
        {
          label: 'weixiudanhao',
          prop: 'no',
          fixed: 'left'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName'
        },
        {
          label: 'baoxiushijian',
          prop: 'createTime',
          type: 'time',
          width: 230
        },
        {
          label: 'baoxiuren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'guzhangmiaoshu',
          prop: 'description'
        },
        {
          label: 'weixiuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            1: {
              color: '#F56C6C',
              text: this.$t('daichuli')
            },
            2: {
              color: '#E6A23C',
              text: this.$t('weixiuzhong')
            },
            3: {
              color: '#67C23A',
              text: this.$t('yiwancheng')
            },
            4: {
              color: '#969696',
              text: this.$t('shibai')
            }
          }
        },
        {
          label: 'jinjichengdu',
          prop: 'level',
          type: 'dictionary',
          key: 'EQUIPMENT_REPAIR_LEVEL',
          width: 150
        },
        {
          label: 'kaishiweixiuren',
          prop: 'repairByObject.nickname'
        },
        {
          label: 'xuqiushijian',
          prop: 'requiredTime',
          type: 'time'
        },
        {
          label: 'weixiudengdanshichang',
          prop: 'repairWaitingTime',
          type: 'slot',
          width: 100
        },
        {
          label: 'weixiuhaoshi',
          prop: 'repairDuration',
          type: 'slot'
        },
        {
          label: 'yanshouzhuangtai',
          prop: 'acceptanceStatus',
          type: 'tag',
          tags: {
            '0': {
              color: '#67C23A',
              text: this.$t('daiyanshou')
            },
            '1': {
              color: '#E6A23C',
              text: this.$t('yiyanshou')
            },
            '2': {
              color: '#F56C6C',
              text: this.$t('yanshouweitongguo')
            }
          }
        },
        {
          label: 'weixiukaishishijian',
          prop: 'startTime',
          type: 'time'
        },
        {
          label: 'wanchengweixiuren',
          prop: 'endRepairerObject.nickname'
        },
        {
          label: 'weixiujieshushijian',
          prop: 'endTime',
          type: 'time'
        },
        {
          label: 'tupian',
          type: 'slot',
          prop: 'repairByObject.nickname'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.getRepairMethod();
    }, 300);
  },
  methods: {
    formatMilliseconds(ms) {
      if (!ms || ms === 0) {
        return;
      }
      // 计算总秒数
      const totalSeconds = Math.floor(ms / 1000);

      // 计算小时
      const hours = (totalSeconds / 3600).toFixed(1);

      // 补零逻辑（仅补有效位）
      return hours + '小时';
    },

    customSave() {
      if (!this.yt.editObj.requiredTime) {
        this.$message.error(this.$t('xuqiushijian_not_null'));
        return;
      }

      this.http
        .post('/web/equipment/repair/bill/create', this.yt.editObj)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    beforeSave(params, url) {
      // params.imageIds = this.imageIds
      // this.imageIds = []
      if (this.yt.editObj.fileInfoIds && this.yt.editObj.fileInfoIds.length > 0) {
        //将this.yt.editObj.fileInfoIds添加到this.yt.editObj.imageIds
        this.yt.editObj.fileInfoIds.forEach(item => {
          params.imageIds.push(item);
        });
      }
      return params;
    },
    afterGet() {
      for (let index = 0; index < this.yt.list.length; index++) {
        if (this.yt.list[index].fileInfos) {
          this.yt.list[index].fileInfoIds = this.yt.list[index].fileInfos.map(item => {
            return item.id;
          });
        } else {
          this.yt.list[index].fileInfoIds = [];
        }
      }
    },
    // 文件上传之后调用
    afterUpload() {
      setTimeout(() => {
        if (!this.$refs.up.loading && !this.isUploadFinish) {
          this.isUploadFinish = true;
          // 更新图片id
          this.http
            .post('/web/equipment/maintain/bill/update/fileIds', {
              id: this.$attrs.maintainItem.id,
              fileIdList: this.imageIds
            })
            .then(res => {
              this.$message.success(this.$t(res.msg));
            })
            .catch(err => {
              this.$message.error(this.$t(err));
            })
            .finally(() => {
              this.isUploadFinish = false;
            });
        }
      }, 1000);
    },
    // 文件移除之后调用
    afterRemove() {
      console.log('afterRemove imageIds', this.imageIds);
      // 更新图片id
      this.http
        .post('/web/equipment/maintain/bill/update/fileIds', {
          id: this.$attrs.maintainItem.id,
          fileIdList: this.imageIds
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    exportExcel() {
      let params = this.yt.conditions;
      params.createTimeStart = params.startTime;
      params.createTimeEnd = params.endTime;
      return this.http
        .get('/web/report/export/equipment_repair_export', { params })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    beforeShowEditDialog(editObj) {
      if (editObj.action === 'wanchengweixiu') {
        editObj.methodList = [
          {
            label: '',
            id: 0
          }
        ];
      }
      return editObj;
    },
    // 请求查询客户数据字典中的维修方法项
    async getRepairMethod() {
      let response = await this.http.get('/web/config/customer/dictionary/item/getDictionaryByTypeCode', {
        params: {
          code: 'SBWXFF'
        }
      });
      this.repairMethod = response.data;
    },
    // 开始维修
    startRepair(editObj) {
      this.$set(editObj, 'startRepairLoading', true);
      this.http
        .post('/web/equipment/repair/bill/start', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.$set(editObj, 'startRepairLoading', false);
        });
    },
    // 添加维修方法项
    addItem() {
      this.yt.editObj.methodList.push({
        method: '',
        remark: '',
        repairRemark: ''
      });
    },
    // 删除维修方法项
    deleteItem(key) {
      this.yt.editObj.methodList = this.yt.editObj.methodList.filter((item, index) => {
        return index !== key;
      });
    },
    // 根据维修记录id查询已成功完成维修的维修详情
    async getRepairMethodItem(obj) {
      let response = await this.http.get('/web/equipment/repair/bill/listMethod', {
        params: {
          repairId: obj.id
        }
      });
      this.repairMethodItemList = response.data;
      this.yt.editObj.methodList = response.data;
    },
    exportDetailExcel() {
      this.exportLoading = true;
      //查询表格
      this.http
        .get('/web/equipment/repair/bill/exportDetail?pageNum=1&pageSize=9999', { params: { ...this.yt.conditions } })
        .then(res => {
          let tableFirst = [this.$t('weixiudanhao'), this.$t('shebeimingcheng'), this.$t('baoxiushijian'), this.$t('baoxiuren'), this.$t('weixiukaishishijian'), this.$t('weixiujieshushijian'), this.$t('youxiaoshijian'), this.$t('weixiudengdaishichang'), this.$t('guzhangmiaoshu'), this.$t('weixiuzhuangtai'), this.$t('jinjichengdu'), this.$t('weixiufangfa'), this.$t('weixiushuoming'), this.$t('caozuoren'), this.$t('beizhu')];
          let tableData = [];
          tableData.push(tableFirst);
          console.log(res.data);
          let listData = res.data.rows;
          if (listData != null && listData != undefined && listData.length > 0) {
            for (let i = 0; i < listData.length; i++) {
              let dataArr = [];
              let item = listData[i];
              console.log(item);
              dataArr[tableFirst.indexOf(this.$t('weixiudanhao'))] = item.no;
              dataArr[tableFirst.indexOf(this.$t('shebeimingcheng'))] = item.equipment ? item.equipment.name : '';
              dataArr[tableFirst.indexOf(this.$t('baoxiushijian'))] = this.dayjs(listData[i].createTime).format('YYYY-MM-DD HH:mm:ss');
              dataArr[tableFirst.indexOf(this.$t('baoxiuren'))] = item.createByObject ? item.createByObject.nickname : '';
              dataArr[tableFirst.indexOf(this.$t('weixiukaishishijian'))] = item.startTime ? this.dayjs(item.startTime).format('YYYY-MM-DD HH:mm:ss') : '';
              dataArr[tableFirst.indexOf(this.$t('weixiujieshushijian'))] = item.endTime ? this.dayjs(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '';
              if (item.startTime && item.endTime) {
                //计算相差的时分秒
                const diff = this.dayjs(item.endTime).diff(this.dayjs(item.startTime));
                const hours = Math.floor(diff / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((diff % (1000 * 60)) / 1000);
                console.log(hours, minutes, seconds);
                dataArr[tableFirst.indexOf(this.$t('youxiaoshijian'))] = `${hours}小时${minutes}分钟${seconds}秒`;
              } else {
                dataArr[tableFirst.indexOf(this.$t('youxiaoshijian'))] = '';
              }
              if (item.repairWaitingTime) {
                const hours = Math.floor(item.repairWaitingTime / (1000 * 60 * 60));
                const minutes = Math.floor((item.repairWaitingTime % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((item.repairWaitingTime % (1000 * 60)) / 1000);
                dataArr[tableFirst.indexOf(this.$t('weixiudengdaishichang'))] = `${hours}小时${minutes}分钟${seconds}秒`;
              }
              dataArr[tableFirst.indexOf(this.$t('guzhangmiaoshu'))] = item.description ? item.description : '';
              dataArr[tableFirst.indexOf(this.$t('weixiuzhuangtai'))] = item.status ? this.statusMap[item.status].text : '';
              dataArr[tableFirst.indexOf(this.$t('jinjichengdu'))] = this.$t(this.store.state.dictJson['EQUIPMENT_REPAIR_LEVEL'][item.level]);
              dataArr[tableFirst.indexOf(this.$t('weixiufangfa'))] = item.method ? this.$t(this.store.state.dictJson['SBWXFF'][item.method]) : '';
              dataArr[tableFirst.indexOf(this.$t('weixiushuoming'))] = item.remark ? item.remark : '';
              dataArr[tableFirst.indexOf(this.$t('caozuoren'))] = item.methodRepairByObject ? item.methodRepairByObject.nickname : '';
              dataArr[tableFirst.indexOf(this.$t('beizhu'))] = item.repairRemark ? item.repairRemark : '';
              tableData.push(dataArr);
            }
          }
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `设备维修明细_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    }
  }
};
</script>
